import { render, staticRenderFns } from "./managementEdit.vue?vue&type=template&id=56ea1538&scoped=true&"
import script from "./managementEdit.vue?vue&type=script&lang=js&"
export * from "./managementEdit.vue?vue&type=script&lang=js&"
import style0 from "./managementEdit.vue?vue&type=style&index=0&id=56ea1538&scoped=true&lang=css&"
import style1 from "@wangeditor/editor/dist/css/style.css?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56ea1538",
  null
  
)

export default component.exports